var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSketch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 232,
    viewBox: "0 0 256 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 0L55.855 7.628L0 82.607L128 231.662L256 82.607L200.146 7.628L128 0Z",
    fill: "#FDB300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 82.6074L128 231.661L51.846 82.6074H0Z",
    fill: "#EB6C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.153 82.6074L128 231.661L255.999 82.6074H204.153Z",
    fill: "#EB6C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8457 82.6074L128 231.661L204.154 82.6074H51.8457Z",
    fill: "#FDAD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8547 7.628L51.8457 82.607L128 0L55.8547 7.628Z",
    fill: "#FDD231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.153 82.607L200.145 7.627L128 0L204.153 82.607Z",
    fill: "#FDD231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.154 82.6069H255.999L200.145 7.62695L204.154 82.6069Z",
    fill: "#FDAD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 82.6069H51.846L55.855 7.62695L0 82.6069Z",
    fill: "#FDAD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 0L51.8457 82.607H204.154L128 0Z",
    fill: "#FEEEB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 232,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketch);
export default __webpack_public_path__ + "static/media/sketch.87c83552c4ec44031d8cd5ebfc7eb151.svg";
export { ForwardRef as ReactComponent };